import { ContainerModule } from "inversify";

import { NavigationRepository } from "../application/store/navigation.repository";
import { InMemNavigationRepository } from "./store/in-mem-navigation.repository";
import { RestNavigationRepository } from "./store/rest-navigation.repository";

export const NavigationModule = new ContainerModule(({ bind }) => {
  bind(NavigationRepository).toDynamicValue(() => {
    return process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true"
      ? new InMemNavigationRepository()
      : new RestNavigationRepository();
  });
});
